import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS].GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]: {
		url:'/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/products/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS].GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT_PREVIEW]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/products/:productId/preview/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS].GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL_POPUP]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/products/:productId/popup/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS].GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/products/:productId/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS].CREATE_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT]: {
		url:'/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/products/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS].PATCH_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/products/:productId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS].PUT_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/products/:productId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS].DELETE_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/products/:productId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}